import { createSlice } from "@reduxjs/toolkit";

const initialRetryFailedFaspayState = {
  listLoading: false,
  actionsLoading: false,
  entities: null,
  meta: { total: 0 },
  links: null,
  error: null,
  retryFailedFaspayForEdit: undefined,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const retryFailedFaspaySlice = createSlice({
  name: "retryFailedFaspay",
  initialState: initialRetryFailedFaspayState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    retryFailedFaspayFetched: (state, action) => {
      const { entities, meta, links } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.meta = meta;
      state.links = links;
    },
    getRetryFailedFaspay: (state, action) => {
      state.actionsLoading = false;
      state.retryFailedFaspayForEdit = action.payload.retryFailedFaspayForEdit;
      state.error = null;
    },
    retryFailedFaspayUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
    },
  },
});
